// Misc
import React, { Component, Fragment, createElement, cloneElement } from 'react'
import PropTypes from 'prop-types'
import withActions from 'react-axios-hoc'
import { withAppSnackbar } from 'atoms/AppSnackbar'

// Validation
import { Validator } from 'react-vld'

// Atoms
import Card from 'atoms/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardHeader from '@material-ui/core/CardHeader'
import Typography from '@material-ui/core/Typography'
import { AppProgressActivator } from 'atoms/AppProgress'

const mapActionsToProps = ({ onSubmit }) => ({
  submitAction: cancelToken => () => onSubmit(cancelToken)
})

@withActions(mapActionsToProps)
@withAppSnackbar()
class FormCard extends Component {
  static propTypes = {
    applyButton: PropTypes.any,
    cancelButton: PropTypes.any,
    children: PropTypes.any,
    component: PropTypes.any,
    showAppSnackbar: PropTypes.func.isRequired,
    submitAction: PropTypes.object.isRequired,
    successMessage: PropTypes.any,
    title: PropTypes.any.isRequired,
    validation: PropTypes.object.isRequired,
  }

  static defaultProps = {
    component: Card,
  }

  handleSubmit = async () => {
    const { validation, submitAction, successMessage, showAppSnackbar } = this.props
    const validatorState = validation.validate()
    if (!submitAction.isPending && validatorState.isValid) {
      try {
        await submitAction.run({ updateComponentOnSuccess: false })
        if (successMessage) showAppSnackbar(successMessage)
      } catch (e) {
        // do nothing
      }
    }
  }

  renderError() {
    const { submitAction } = this.props
    return submitAction.isFailed && (
      <CardContent>
        <Typography color="error">
          { submitAction.error.message }
        </Typography>
      </CardContent>
    )
  }

  renderSubmitButton() {
    const { applyButton } = this.props
    return !!applyButton && cloneElement(applyButton, {
      onClick: this.handleSubmit,
      type: 'button',
      size: 'small',
      color: 'secondary',
      ...applyButton.props,
    })
  }

  renderCancelButton() {
    const { cancelButton } = this.props
    return !!cancelButton && cloneElement(cancelButton, {
      type: 'button',
      size: 'small',
      color: 'secondary',
      ...cancelButton.props,
    })
  }

  render() {
    const { component, submitAction, title, children } = this.props
    return (
      <Fragment>
        { submitAction.isPending && <AppProgressActivator /> }
        { createElement(component, {}, (
          <Fragment>
            <CardHeader title={title} />
            { children }
            { this.renderError() }
            <CardActions>
              { this.renderSubmitButton() }
              { this.renderCancelButton() }
            </CardActions>
          </Fragment>
        )) }
      </Fragment>
    )
  }
}

export default function FormCardValidator(props) {
  return (
    <Validator>
      { validation => (
        <FormCard {...props} validation={validation} />
      ) }
    </Validator>
  )
}
